module.exports = __webpack_public_path__ + "img/27.7842d4d1.jpg";